const envBase = process.env.REACT_APP_API_URL;

const BASE_URL =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? envBase
    : window.location.origin;

export default BASE_URL;
